import { useThemeProps as systemUseThemeProps } from '@mui/system';
import defaultTheme from './defaultTheme';
export default function useThemeProps({
  props,
  name
}) {
  return systemUseThemeProps({
    props,
    name,
    defaultTheme
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/styles/useThemeProps.js
// module id = 9
// module chunks = 1